import {IconContainer} from '@components/ui/icon-container'
import {Button} from '@components/ui/button'
import {Container} from '@components/ui/container'
import {FC, ReactNode} from 'react'

interface ErrorBoxProps {
    cta?: ReturnType<typeof Button>
    icon: ReactNode
    title: string
}
export const ErrorBox: FC<ErrorBoxProps> = ({cta, icon, title}) => {
    return (
        <Container fullHeight className="flex items-center justify-center">
            <div className="flex max-w-5xl flex-col items-center justify-items-center gap-6">
                <IconContainer>{icon}</IconContainer>
                <h1 className="text-display-xs text-center font-semibold text-neutral-900">{title}</h1>
                {cta}
            </div>
        </Container>
    )
}

ErrorBox.displayName = 'ErrorBox'
